import Button from '@/components/Button.jsx';
import HelpIcon from '@/components/HelpIcon.jsx';
import ToggleIndicator from '@/components/ToggleIndicator.jsx';
import DividerV2 from '@/components/v2/DividerV2.jsx';
import { DeleteIcon } from '@/lib/constants/icons.js';
import setQuery from '@/lib/setQuery';
import { useEffect, useState } from 'react';

const PanelSection = ({ title, description, section, children, rightContent, leftContent, collapseByDefault = false, collapsable = true, headerless = false, className = '', gap = 'md', helpIconContext, onDelete, queryName, onChange, variant = 'default', ...props }) => {
  const [isOpen, setIsOpen] = useState(!collapseByDefault);

  const toggleSection = () => {
    if (!collapsable) return;

    setIsOpen((prev) => !prev);

    if (onChange) {
      onChange(isOpen);
    }
  };

  const descriptionLines = description
    ?.split(/\n/)
    ?.map((n) => n?.trim())
    ?.filter((n) => !!n);

  useEffect(() => {
    if (queryName) {
      setQuery({ [queryName]: isOpen ? true : undefined });
    }
  }, [queryName, isOpen]);

  const TitleElement = typeof title === 'function' ? <div>{title()}</div> : <span>{title}</span>;

  return (
    <div id={queryName ? `section-${queryName}` : undefined} className={`comp-panel-section ${className} ${!isOpen ? 'collapsed' : ''} variant-${variant}`} data-section={section} {...props}>
      {!headerless && (
        <>
          <div className={`comp-panel-section-title ${!isOpen ? 'collapsed' : ''}`} onClick={toggleSection} style={{ cursor: collapsable ? 'pointer' : 'default' }}>
            {TitleElement}
            {leftContent}
            {helpIconContext && isOpen && <HelpIcon context={helpIconContext} />}
            {onDelete && <Button size={'sm'} icon={DeleteIcon} className={'ghost'} onClick={onDelete} />}
            <DividerV2 style={{ cursor: collapsable ? 'pointer' : 'default' }} />
            {rightContent}
            {collapsable && <ToggleIndicator isOpen={isOpen} />}
          </div>
          {description && isOpen && (
            <div className="comp-panel-section-description">
              {descriptionLines?.map((line, idx) => (
                <div className={'description-line'} key={idx}>
                  {line}
                </div>
              ))}
            </div>
          )}
        </>
      )}
      {isOpen && !!children && <div className={`comp-panel-section-content gap-${gap}`}>{children}</div>}
    </div>
  );
};

export default PanelSection;
